import { App } from '@web/query/App';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  feature: PlatformFeatures | PlatformFeatures[];
  /**
   * For an array of features, whether all must be enabled ('all', default) or any one of them ('any').
   */
  match?: 'all' | 'any';
  invert?: boolean;
}

function RenderIfFeatureAvailable({ feature, children, match = 'all', invert }: Props) {
  const { data } = App.useFeatures();
  const features = Array.isArray(feature) ? feature : [feature];
  const available = match === 'any' ? features.some((f) => data?.[f]) : features.every((f) => data?.[f]);
  const needToShow = invert ? !available : available;

  return needToShow ? children : null;
}

export { RenderIfFeatureAvailable };
